import Vue from 'vue'
import Vuex from 'vuex'
import {firestoreAction, vuexfireMutations} from 'vuexfire'
import {db} from "@/plugins/db";
import user from "./user"
import activity from "./activity"
import auth from "./auth"
import history from "./history"
import avatar from "./avatar"
import practice from "./practice"
import pictionary from "./pictionary"
import video from "./video"
import game from "./game"
import VuexPersist from 'vuex-persist'


const vuexPersist = new VuexPersist({
  key: 'omevirtual',
  storage: window.localStorage
});

Vue.use(Vuex);
interface StateInterface {
  loading: boolean;
  error: any;
}

const initPageState = () => {
  return {
    loading: false,
    error: null as any
  };
};

export default new Vuex.Store({
  state: initPageState(),
  mutations: {
    setLoading (state: any, payload) {
      state.loading = payload
    },
    setError (state: any, payload) {
      state.error = payload
    },
    clearError (state: any) {
      state.error = null
    },
    ...vuexfireMutations
  },
  actions: {
    editCollect:firestoreAction(({ commit }, data ) => {
      commit('setLoading', true);
      return db
          .collection(data.collection)
          .doc(data.id)
          .update(data.data)
          .then(() => {
            commit('setLoading', false);
          }).catch((e) => {
            alert(e);
            commit('setLoading', false);
          })
    }),
    deleteCollect:firestoreAction(({ commit }, data ) => {
      commit('setLoading', true);
      return db
          .collection(data.collection)
          .doc(data.id)
          .delete()
          .then(() => {
            commit('setLoading', false);
          }).catch((e) => {
            alert(e);
            commit('setLoading', false);
          })
    })
  },
  modules: {
    practice,
    user,
    activity,
    auth,
    history,
    avatar,
    pictionary,
    video,
    game
  },
  plugins: [vuexPersist.plugin]
})
